module.exports = __webpack_public_path__ + "static/media/facebook-mobile.d15c8ec3.svg";